import { SvgPdsIcon } from './SvgPdsIcon'

export default SvgPdsIcon
